/** @format */

import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { Button, Drawer, Form, FormItem, Input, Radio, Checkbox, Message } from '@king-design/react'
import { useAsync, useAsyncFn } from 'react-use'
import { getEvaluateInfo, saveEvaluate } from 'src/api/ApiEventOpsRecord'

import { RecordItemProp } from '../container'

interface EvaluateInfoProps {
  rightResult: { label: string; value: string }[]
  missResult: { label: string; value: string }[]
}
interface EvalateProps {
  className?: string
  baseInfo: RecordItemProp // 记录信息
  updateRecord: () => void
  evaluation: boolean
  evaluateInfo: EvaluateInfoProps
}

interface LogFormValuesProps {
  ResultAllTrue: boolean
  RightSigns: string[]
  MissSigns: string[]
  EvaluateRemark: string
}
const initLogFormValues: LogFormValuesProps = {
  ResultAllTrue: true,
  RightSigns: [],
  MissSigns: [],
  EvaluateRemark: ''
}

const Evalate: React.FC<EvalateProps> = ({ className, baseInfo, evaluateInfo, updateRecord }) => {
  // 日志抽屉
  const [visible, setVisible] = useState(false)
  const formRef = useRef(null)
  const [formValues, setFormValues] = useState<LogFormValuesProps>(initLogFormValues)

  useAsync(async () => {
    if (visible) {
      if (baseInfo.Evaluation !== 1) {
        const result = await getEvaluateInfo(baseInfo.ID)
        const { ResultAllTrue, EvaluateRemark } = result
        setFormValues({
          ResultAllTrue,
          RightSigns: result?.RightNodes?.map(item => item.WfProcessNodeSign),
          MissSigns: result?.MissNodes?.map(item => item.WfProcessNodeSign),
          EvaluateRemark
        })
      } else {
        setFormValues(initLogFormValues)
      }
    }
  }, [visible, baseInfo])

  // 保存评价
  const [, fetchSaveEvaluate] = useAsyncFn(async params => {
    const result = await saveEvaluate(params)
    if (result) {
      Message.success('保存成功')
      setVisible(false)
      setFormValues(initLogFormValues)
      updateRecord()
    }
  }, [])

  return (
    <div id="evalate_btn" className={className}>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true)
        }}
      >
        评价
      </Button>
      <Drawer
        value={visible}
        width={600}
        title="评价"
        mode="destroy"
        container={() => document.querySelector('#evalate_btn')}
        onChangeValue={show => {
          if (!show) {
            setVisible(false)
            setFormValues(initLogFormValues)
          }
        }}
        ok={async () => {
          const validate = await formRef.current.validate()
          if (validate) {
            fetchSaveEvaluate({ ...formValues, RecordID: baseInfo.ID })
          }
        }}
      >
        <Form starOnRequired ref={formRef} labelWidth={100} className="form_content">
          <FormItem label="定位结果" value={formValues.ResultAllTrue}>
            <div className="ksc-space">
              <Radio
                name="ResultAllTrue"
                trueValue={true}
                value={formValues.ResultAllTrue}
                onChangeValue={() => {
                  setFormValues({
                    ...formValues,
                    ResultAllTrue: true,
                    RightSigns: evaluateInfo?.rightResult?.map(item => item.value),
                    MissSigns: []
                  })
                }}
              >
                全部正确
              </Radio>
              <Radio
                name="ResultAllTrue"
                trueValue={false}
                value={formValues.ResultAllTrue}
                onChangeValue={() => {
                  setFormValues({
                    ...formValues,
                    ResultAllTrue: false,
                    RightSigns: [],
                    MissSigns: []
                  })
                }}
              >
                存在误判
              </Radio>
            </div>
            <p className="form_item_tip">本次定位结果是否全部正确？</p>
          </FormItem>
          {!formValues.ResultAllTrue && evaluateInfo?.rightResult?.length ? (
            <FormItem label="正确结果" value={formValues.RightSigns}>
              <div className="ksc-space">
                {evaluateInfo?.rightResult?.map(item => (
                  <Checkbox
                    key={item.value}
                    trueValue={item.value}
                    value={formValues.RightSigns}
                    onChangeValue={value => {
                      setFormValues({
                        ...formValues,
                        RightSigns: Array.isArray(value) ? value : [value]
                      })
                    }}
                  >
                    {item.label}
                  </Checkbox>
                ))}
              </div>
              <p className="form_item_tip">上述结果哪些项是定位正确的结果？</p>
            </FormItem>
          ) : null}
          {!formValues.ResultAllTrue && evaluateInfo?.missResult?.length ? (
            <FormItem label="遗漏结果" value={formValues.MissSigns}>
              <div className="ksc-space">
                {evaluateInfo?.missResult?.map(item => (
                  <Checkbox
                    key={item.value}
                    trueValue={item.value}
                    value={formValues.MissSigns}
                    onChangeValue={value => {
                      setFormValues({
                        ...formValues,
                        MissSigns: value
                      })
                    }}
                  >
                    {item.label}
                  </Checkbox>
                ))}
              </div>
              <p className="form_item_tip">上述哪些项是真正结果，但系统没有定位到？</p>
            </FormItem>
          ) : null}
          <FormItem label="评价备注" value={formValues.EvaluateRemark}>
            <Input
              width={450}
              type="textarea"
              rows={4}
              value={formValues.EvaluateRemark}
              onChangeValue={value => {
                setFormValues({ ...formValues, EvaluateRemark: value })
              }}
            />
          </FormItem>
        </Form>
      </Drawer>
    </div>
  )
}

export default styled(Evalate)`
  .k-form-item {
    align-items: flex-start;
    .k-form-content {
      .form_item_tip {
        margin-top: 8px;
        font-size: 12px;
        color: #999;
      }
    }
  }
`
